import styled, { css } from "styled-components";
import { Carousel } from "react-responsive-carousel";
import { bp } from "theme";
import { Section, Container } from "../../styles/commonStyles";
import { carouselCss } from "../../styles/carouselStyles";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import AmazonLogo from "../../assets/svgs/AmazonLogo";
import SwiggyLogo from "../../assets/svgs/SwiggyLogo";
import TopprLogo from "../../assets/svgs/TopprLogo";
import DunzoLogo from "../../assets/svgs/DunzoLogo";
import MedlifeLogo from "../../assets/svgs/MedlifeLogo";
import SodexoLogo from "../../assets/svgs/SodexoLogo";
import PorteaLogo from "../../assets/svgs/PorteaLogo";
import { CLOUDINARY_BASE_URL } from "../../utils/constants";

const CustomerLogos = ({ bgColor }) => (
	<MainSection bgColor={bgColor || "#fff"}>
		<CarouselContainer>
			<SectionHeading>
				<OtherHeadingWord>
					<TopHeadingWord>Top Brands</TopHeadingWord> trust apna. Start hiring
					now!
				</OtherHeadingWord>
			</SectionHeading>
			<Carousel
				showArrows={false}
				showStatus={false}
				showThumbs={false}
				swipeable
				emulateTouch
				autoPlay
				interval={5000}
				infiniteLoop
			>
				<div>
					<LogosContainer>
						<LogosWrapper>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/byjus-logo_vk1ydj.png`}
									loading="lazy"
									alt="Byju's Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/shaadi-logo_ktxbvy.png`}
									loading="lazy"
									alt="Shaadi Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/whitehat-logo_xat5th.png`}
									loading="lazy"
									alt="WhitehatJr Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/flipkartIcon_uottj3.jpg`}
									loading="lazy"
									alt="Flipkart Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<SwiggyLogo height={55} style={{ maxWidth: "150px" }} />
							</Logos>
							<Logos>
								<AmazonLogo style={{ maxWidth: "150px" }} />
							</Logos>
							<Logos>
								<TopprLogo />
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/unacademy-logo_gjgzxp.png`}
									loading="lazy"
									alt="Unacademy Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/bigbasket-logo_jfbaen.png`}
									loading="lazy"
									alt="BigBasket Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos hideOnMobileView>
								<SodexoLogo style={{ maxWidth: "150px" }} />
							</Logos>
						</LogosWrapper>
					</LogosContainer>
				</div>
				<div>
					<LogosContainer>
						<LogosWrapper>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/bluestar-logo_dkepq5.png`}
									loading="lazy"
									alt="Bluestar Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/coffee-day-logo_hzosi2.png`}
									loading="lazy"
									alt="CoffeeDay Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/generico-logo_hwhfk6.png`}
									loading="lazy"
									alt="Generico Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<MedlifeLogo style={{ maxWidth: "110px" }} />
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/pharmeasy-logo_fhllqo.png`}
									loading="lazy"
									alt="Pharmeasy Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<DunzoLogo />
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/cloudnine-logo_sqjpfj.png`}
									loading="lazy"
									alt="Cloud Nine Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/licious-logo_c5qcvm.png`}
									loading="lazy"
									alt="Licious Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/StarQuik-logo_cf36j2.png`}
									loading="lazy"
									alt="StarQuik Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<PorteaLogo style={{ maxWidth: "150px" }} />
							</Logos>
						</LogosWrapper>
					</LogosContainer>
				</div>
				<div>
					<LogosContainer>
						<LogosWrapper>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/home_page_images/team_lease_logo_latest.png`}
									loading="lazy"
									alt="Teamlease Logo"
									height={120}
									width={120}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/fortis-logo_yzeadn.png`}
									loading="lazy"
									alt="Fortis Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/wellness-forever-logo_ai4xnz.png`}
									loading="lazy"
									alt="Wellness Forever Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/grofers-logo_pzpndt.png`}
									loading="lazy"
									alt="Grofers Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/shadowfax-logo_tczl3s.png`}
									loading="lazy"
									alt="Shadowfax Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/drivify-logo_hu0jes.png`}
									loading="lazy"
									alt="Drivify Logo"
									height={120}
									width={100}
								/>
							</Logos>
							<Logos>
								<LogoImage
									src={`${CLOUDINARY_BASE_URL}/Taco%20Bell%20Logo.png`}
									loading="lazy"
									alt="Taco Bell Logo"
									height={120}
									width={100}
								/>
							</Logos>
						</LogosWrapper>
					</LogosContainer>
				</div>
			</Carousel>
		</CarouselContainer>
	</MainSection>
);

// Styles
const MainSection = styled(Section)`
	z-index: 3;
	position: relative;
	border-top: 1px solid rgba(77, 57, 81, 0.2);

	${mediaMaxWidth.medium`
		border-top 1px solid #4d3951;
	`}
`;
const SectionHeading = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
const OtherHeadingWord = styled.h2`
	font-size: 24px;
	font-weight: normal;
	line-height: 2.17;
	text-align: center;
	color: #373737;
`;
const TopHeadingWord = styled.span`
	font-weight: 600;
	${bp.md} {
		font-weight: 900;
		position: relative;
		&::after {
			content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="99" height="17" viewBox="0 0 99 17"><path fill="none" fill-rule="evenodd" stroke="%23FFD166" stroke-linecap="round" stroke-width="5" d="M96.469 7.857C66.932 2.113 29.437-2.73 2.628 14.049"/></svg>');
			position: absolute;
			bottom: -32px;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
`;

const LogosContainer = styled.div``;
const LogosWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
`;
const Logos = styled.div`
	width: 100%;
	max-width: 190px;
	min-height: 100px;
	margin: 15px 15px !important;
	display: flex;
	align-items: center;
	justify-content: center;

	& svg {
		width: 100%;
		height: auto;
	}

	${(props) =>
		props.hideOnMobileView &&
		css`
			${mediaMaxWidth.medium`
            display: none;
        `}
		`}

	${mediaMaxWidth.medium`
		max-width: 120px;
		min-height: 66px;
	`}
`;
const LogoImage = styled.img`
	width: 100px;
	height: 120px;
	object-fit: contain;
`;

const CarouselContainer = styled(Container)`
	${carouselCss};
	& {
		.carousel .slide {
			background-color: transparent;
			margin-bottom: 70px;
		}
		.carousel .control-dots .dot {
			background: #4d3951;
			opacity: 0.2;
		}
	}

	padding: 70px 0 30px;
`;

export default CustomerLogos;
